import { render, staticRenderFns } from "./Offertags.vue?vue&type=template&id=ec732fc6&scoped=true&"
import script from "./Offertags.vue?vue&type=script&lang=js&"
export * from "./Offertags.vue?vue&type=script&lang=js&"
import style0 from "./Offertags.vue?vue&type=style&index=0&id=ec732fc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec732fc6",
  null
  
)

export default component.exports